var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-demo"},[_c('div',{staticClass:"icon-field"},[_c('el-card',[_c('vue-file-toolbar-menu',{attrs:{"content":_vm.my_menu_one}})],1),_c('el-card',[_c('vue-file-toolbar-menu',{attrs:{"content":_vm.my_menu_two}})],1),_c('el-card',[_c('vue-file-toolbar-menu',{attrs:{"content":_vm.my_menu_three}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }